<template>
  <el-container class="main-index">
    <el-main class="content">
      <el-aside :class="{ toggle : subMenuWidth < 100 }" width="200" class="tree-map">
        <main-menu></main-menu>
      </el-aside>
      <el-main :class="{ toggle: subMenuWidth < 100 }" class="right">
        <main-content></main-content>
      </el-main>
    </el-main>
  </el-container>
</template>

<script>
  import MainMenu from './menu.vue'
  import MainContent from './content'
  import { mapGetters } from 'vuex'

  export default {
    components: { MainMenu, MainContent },
    data() {
      return {}
    },
    methods: {},
    computed: {
      ...mapGetters([
        'subMenuWidth'
      ])
    }
  }
</script>

<style lang="stylus">
  .main-index
    height 100%
    .el-button--primary
      background-color #4164e3
      border-color #4164e3
    .header
      padding 0
    .content
      padding 0
      display flex
      .tree-map
        color #333
        border-right solid 1px #e6e6e6
        height 100%
        background-color #262A35
        position absolute
        overflow auto
        &.toggle
          width 80px
          overflow hidden
          transition width 0.8s linear
        .el-menu
          border-right none
          background-color #262A35
      .right
        position relative
        padding 0
        flex 1
        margin-left 260px
        &.toggle
          margin-left 80px
          transition all 0.2s linear
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner
      background-color #4164e3
      border-color #4164e3
    .el-select .el-input.is-focus
      .el-input__inner
        border-color #4164e3
    .el-input__inner:focus
      border-color #4164e3
  .el-message-box__btns
    .el-button--primary,
    .el-button--primary:focus
      background-color #4164e3
      border-color #4164e3
  .el-scrollbar
    .el-select-dropdown__item.selected
      color #4164e3
  .el-picker-panel__body
    .el-month-table td.current:not(.disabled) .cell
      color #4164e3
    .el-year-table td .cell:hover, .el-year-table td.current:not(.disabled) .cell
      color #4164e3
  .search-input2.el-select
    width 265px
    .el-select__tags
      width 265px !important
      max-width 265px !important
      & > span
        display flex
      .el-tag__close.el-icon-close
        top -7px
      .el-select__tags-text
        display inline-block
        max-width 180px
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
  .el-select-dropdown__item.selected
    span
      display inline-block
      max-width 180px
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
</style>
